var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowDownGray({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 12,
    viewBox: "0 0 20 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.46995 0.968387C9.53962 0.898542 9.62238 0.843128 9.7135 0.805318C9.80462 0.767508 9.9023 0.748047 10.0009 0.748047C10.0996 0.748047 10.1973 0.767508 10.2884 0.805318C10.3795 0.843128 10.4623 0.898542 10.5319 0.968387L19.5319 9.96839C19.6728 10.1092 19.7519 10.3002 19.7519 10.4994C19.7519 10.6985 19.6728 10.8896 19.5319 11.0304C19.3911 11.1712 19.2001 11.2503 19.0009 11.2503C18.8018 11.2503 18.6108 11.1712 18.4699 11.0304L10.0009 2.55989L1.53195 11.0304C1.39112 11.1712 1.20011 11.2503 1.00095 11.2503C0.801784 11.2503 0.610777 11.1712 0.469947 11.0304C0.329117 10.8896 0.25 10.6985 0.25 10.4994C0.25 10.3002 0.329117 10.1092 0.469947 9.96839L9.46995 0.968387Z",
    fill: "#828282"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDownGray);
export default __webpack_public_path__ + "static/media/arrowDownGray.ad183858a277eb395d8572be3b104fd1.svg";
export { ForwardRef as ReactComponent };